import { BrowserRouter, Route, Routes } from 'react-router';
import { SigninCallback } from '@/generic/authentication';
import { Layout } from '@/cleanapi/Layout.tsx';
import { AnonymousLayout } from '@/cleanapi/AnonymousLayout.tsx';
import { lazy, Suspense } from 'react';

const DiagnosticApp = lazy(async () => {
  const { DiagnosticApp } = await import('@/diagnostic');
  return { default: DiagnosticApp };
});

const DiagnosticHistoryApp = lazy(async () => {
  const { DiagnosticHistoryApp } = await import('@/diagnostic');
  return { default: DiagnosticHistoryApp };
});

const RulesApp = lazy(async () => {
  const { RulesApp } = await import('@/rules-management');
  return { default: RulesApp };
});

export const CleanApiApp = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<Layout />}>
        <Route
          path="/"
          element={
            <Suspense>
              <DiagnosticApp />
            </Suspense>
          }
        />
        <Route
          path="/history"
          element={
            <Suspense>
              <DiagnosticHistoryApp />
            </Suspense>
          }
        />
        <Route
          path="/rules"
          element={
            <Suspense>
              <RulesApp />
            </Suspense>
          }
        />
      </Route>
      <Route element={<AnonymousLayout />}>
        <Route path="/signin-callback" element={<SigninCallback />} />
      </Route>
    </Routes>
  </BrowserRouter>
);
